// removed by extract-text-webpack-plugin
module.exports = {"container":"_2YwIGVQBzpjDRnajtsPaUe","state":"_3PRIR_ZNXuun3ZeMU-MTF6","sign":"Q36856WMKmxRHWlHA8HOz","btnCancelar":"_2yFVeEOx-BQhVqESLxzdIl","signButton":"_2vocfVKwQxnWmsqUKXfA-w","checkboxAdjuntos":"_1msBQPgoJ07bEHyuqBQQS9","feaState":"_1sF8-K8bZIZLCUDhPpIojp","btnHeader":"_39a4sHJCxQxtU8Tw3mUTGg","instructions":"_3ZvmJUOM6B2XAr3R26mMgk","large":"_1vZxtsb5PneJDx5CzoMplC"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/Status/Title/FaceData/styles.css
// module id = 2845
// module chunks = 0